import React, { useState, useEffect } from "react";
import ProductCard from "../Products/ProductCard";
import algoliasearch from "algoliasearch";
import { useParams, useLocation, Link } from "react-router-dom";
import useSearchedProducts from "../StatesStore/searchedProducts";
import useSearchFilter from "../StatesStore/SearchFilters";
import UserProfileCard from "../Header/userProfileCard";
import { UserAuth } from "../Context";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import ProductCard6 from "../Products/ProductCard6";
import ShoppingList from "./ShoppingList";
import { collection, doc, getDocs, query, where } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { saveShoppingListToAlgolia } from "../lib/algoliaFunctions";
import ProductCard9 from "../Products/ProductCard9";
//algolia object initialization and index mapping
const clientLive = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID_LIVE,
  process.env.REACT_APP_ALGOLIA_ADMIN_KEY_LIVE
);
const clientTest = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID,
  process.env.REACT_APP_ALGOLIA_ADMIN_KEY
);

const index = clientLive.initIndex("products"); //name of index in algolia is products
const indexUsers = clientTest.initIndex("users"); // Name of index in Algolia is users
const indexShoppingList = clientTest.initIndex("shoppingList"); // Name of index in Algolia is shoppingList

export default function SearchResults() {
  //**********************  Router Functions  **********************************//
  const location = useLocation();
  const { input } = useParams();
  const { products } = useSearchedProducts();

  //*********************** other states     *************************************/
  const [allProducts, setAllProducts] = useState([]);
  const [allUsers, setAllUsers] = useState([]); // Corrected line
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [countLeftUser, setCountLeftUser] = useState(false);
  const [countLeftProduct, setCountLeftProduct] = useState(false);
  const [paramInput, setParamInput] = useState(input);
  const [totalProductCount, setTotalProductCount] = useState(0); //total product count
  const [totalUserCount, setTotalUserCount] = useState(0); //total User count
  const [allShoppingLists, setAllShoppingLists] = useState([]);
  const [countLeftShoppingList, setCountLeftShoppingList] = useState(false);
  const [totalShoppingListCount, setTotalShoppingListCount] = useState(0); //total User count
  console.log("totalProductCount from sr", totalProductCount);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const { user } = UserAuth();
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [result, setResult] = useState(false);
  const { setSearchedProduct } = useSearchedProducts();
  const searchFilter = useSearchFilter((state) => state.SearchFilter);

  //******************************* Functions **********************************************/
  useEffect(() => {
    setResult(false);
    setAllProducts([]);
    setSearchedProduct([]);
    setParamInput(input);
    retrieveData();
    setResult(true);
  }, [location.pathname, input]); //only updates when user refreshes

  //**********************   Handle Load More ********************************************/
  // ****************** async call to retrieve data **************************************/
  const retrieveData = async () => {
    if (input.length >= 3) {
      // console.log('Page before fetch: ', page);
      try {
        const offset = 0;
        const data = await index.search(input, {
          offset,
          length: itemsPerPage,
        });
        setLoading(false);

        // Create a Set to ensure unique products
        const uniqueProducts = new Set([...allProducts, ...data.hits]);

        // Convert the Set back to an array
        const updatedProducts = Array.from(uniqueProducts);

        setAllProducts(updatedProducts);
        setTotalProductCount(data.nbHits);
        setSearchedProduct(data.hits);
        console.log("Search Results: data of products", data);

        if (data.nbHits - data.length > 0) {
          setCountLeftProduct(data.nbHits - data.length);
        } else {
          setCountLeftProduct(0);
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }

      try {
        const offset = 0;
        const data = await indexUsers.search(input, {
          offset,
          length: 6,
          typoTolerance: "strict", // Enable strict typo tolerance
          // Contexts:['firstName', 'lastName', 'email', 'userName'], // Searchable contexts
          synonyms: false, // Disable synonyms
        });

        // // Create a Set to store unique users based on a unique identifier (e.g., user ID)
        // const uniqueUserSet = new Set(allUsers.map(user => user.email));

        // // Filter out duplicates and convert back to an array
        // const uniqueUsers = data.hits.filter(user => !uniqueUserSet.has(user.email));
        console.log("Search Results: Users data", data);
        setLoading(false);
        const uniqueUsers = data.hits.filter(
          (user) => user.objectUser?.isVerified
        );
        // setAllUsers(uniqueUsers);
        setAllUsers(data.hits);
        setTotalUserCount(data.nbHits);
        setCountLeftUser(data.nbHits - data.length);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }

      try {
        const offset = 0;
        const data = await indexShoppingList.search(input, {
          typoTolerance: "strict", // Enable strict typo tolerance
          synonyms: false, // Disable synonyms
        });

        // // Create a Set to store unique users based on a unique identifier (e.g., user ID)
        // const uniqueUserSet = new Set(allUsers.map(user => user.email));

        // // Filter out duplicates and convert back to an array
        // const uniqueUsers = data.hits.filter(user => !uniqueUserSet.has(user.email));
        console.log("Search Results: Shopping Lists data", data);
        setLoading(false);
        // const uniqueShoppingLists = data.hits.filter(
        //   (user) => user.visibility === "public"
        // );
        // setAllShoppingLists(uniqueShoppingLists);
        setAllShoppingLists(data.hits);
        setTotalShoppingListCount(data.nbHits);
        setCountLeftShoppingList(data.nbHits > offset + itemsPerPage);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    }
  };
  // console.log('global products in search 1111', products);
  const filteredProducts = products.filter(
    (product) =>
      (searchFilter.gender.length === 0 ||
        searchFilter.gender.includes(product.category)) &&
      (searchFilter.brand.length === 0 ||
        searchFilter.brand.includes(product.supplier)) &&
      searchFilter.minprice <= product.newPrice &&
      searchFilter.maxprice >= product.newPrice
  );

  // console.log("value of countLeft page :", countLeftProduct);
  const getAllShoppingLists = async () => {
    try {
      const usersRef = collection(db, "users");
      const usersSnap = await getDocs(usersRef);
      await Promise.all(
        usersSnap.docs.map(async (user) => {
          const userRef = doc(db, "users", user?.id);
          const shoppingListRef = collection(userRef, "shoppingList");
          let q;
          // q = query(shoppingListRef);
          q = query(shoppingListRef, where("visibility", "==", "Public")); // Fetch only public shopping lists
          try {
            const shoppingListDocs = await getDocs(q);
            const shoppingListData = shoppingListDocs.docs.map(
              async (document) => {
                return saveShoppingListToAlgolia(user, document.id);
              }
            );
            await Promise.all(shoppingListData);
          } catch (error) {
            console.error("Error setting up snapshot listener:", error);
          }
        })
      );
    } catch (error) {
      console.error(error);
    }
    {
      /* {
  "id": "Favorites (2)",
  "name": "Favorites (2)",
  "dateCreated": 1742339935,
  "lastUpdated": 1742341185,
  "products": [
    {
      "id": "12599325753504",
      "timestamp": {
        "seconds": 1742339936,
        "nanoseconds": 45000000
      },
      "likeCount": 0,
      "updatedAt": {
        "seconds": 1742339936,
        "nanoseconds": 45000000
      },
      "size": []
    },
    {
      "id": "12706201436320",
      "timestamp": {
        "seconds": 1742339936,
        "nanoseconds": 228000000
      },
      "likeCount": 0,
      "updatedAt": {
        "seconds": 1742339936,
        "nanoseconds": 228000000
      },
      "size": []
    }
  ],
  "listId": "a97132e5-92d2-4849-819a-c01e4d471ad2",
  "visibility": "public",
  "ownerId": "2owZ9Nyd9gauVFtCiGi8W6kHcj72",
  "objectID": "cfb51b4d2c309_dashboard_generated_id"
}
  */
    }
  };

  return (
    // <div className="col-md-8 col-lg-6 vstack p-0 mt-0 mt-lg-5 ">
    <div
      className="d-flex flex-column w-100"
      style={{
        gap: isSmallScreen ? "16px" : "30px",
        paddingTop: isSmallScreen ? "0px" : "20px",
      }}
    >
      {loading ? (
        <LoadingSpinner />
      ) : allUsers.length === 0 &&
        filteredProducts.length === 0 &&
        allShoppingLists.length === 0 ? (
        <div
          style={{ height: "35rem" }}
          className="w-100 card d-flex justify-content-center align-items-center"
        >
          <h3 className="fw-semibold">
            No Users or Products or Shopping Lists Found
          </h3>
        </div>
      ) : (
        <></>
      )}
      {/* <div className="btn btn-primary w-100 mb-3" onClick={getAllShoppingLists}>
        Add all data of shopping list
      </div> */}
      {allUsers.length > 0 && (
        <div
          className="userSection d-flex flex-column px-md-0"
          style={{ gap: "16px", padding: "0px 6px" }}
        >
          {result && (
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                fontFamily: "Inter",
                fontWeight: "500",
                letterSpacing: "0%",
              }}
            >
              <div
                style={{
                  fontSize: isSmallScreen ? "20px" : "22px",
                  color: "#000000",
                }}
              >
                Users
              </div>
              {countLeftUser > 0 && (
                <Link
                  to={`${location.pathname}/users`}
                  className="nav-link"
                  style={{
                    fontSize: isSmallScreen ? "12px" : "14px",
                    color: "#005FDA",
                  }}
                >
                  <u>View All {totalUserCount} Users</u>
                </Link>
              )}
            </div>
          )}
          <div
            className="row mx-0"
            style={{ padding: isSmallScreen ? "0px 0px" : "10px 0px" }}
          >
            {allUsers.length > 0 &&
              allUsers?.map((searchUser, index) => {
                return (
                  <div
                    className="col-6 col-sm-4 col-md-3 col-lg-2 m-0"
                    style={{
                      padding: isSmallScreen
                        ? index % 2 === 0
                          ? "6px 3px 6px 0px"
                          : index % 2 === 1
                          ? "6px 0px 6px 3px"
                          : "6px 6px"
                        : index % 6 === 0
                        ? "0px 6px 0px 0px"
                        : index % 6 === 5
                        ? "0px 0px 0px 6px"
                        : "0px 6px",
                    }}
                  >
                    <UserProfileCard
                      key={index}
                      searchUser={searchUser}
                      user={user}
                      index={index}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      )}
      {filteredProducts.length > 0 && (
        <div
          className="productsSection d-flex flex-column px-md-0"
          style={{ gap: "16px", padding: "0px 3px" }}
        >
          {result && (
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                padding: "0px 3px",
                fontFamily: "Inter",
                fontWeight: "500",
                letterSpacing: "0%",
              }}
            >
              <div
                style={{
                  fontSize: isSmallScreen ? "20px" : "22px",
                  color: "#000000",
                }}
              >
                Products
              </div>
              {countLeftProduct > 0 && (
                <Link
                  to={`${location.pathname}/products`}
                  className="nav-link"
                  style={{
                    fontSize: isSmallScreen ? "12px" : "14px",
                    color: "#005FDA",
                  }}
                >
                  <u>View All {totalProductCount} Products</u>
                </Link>
              )}
            </div>
          )}
          <div className="row mx-0">
            {filteredProducts.length > 0 &&
              filteredProducts.map((product, index) => (
                <ProductCard9 key={index} product={product} />
              ))}
          </div>
        </div>
      )}
      {allShoppingLists.length > 0 && (
        <div
          className="shoppingListsSection d-flex flex-column px-md-0"
          style={{ gap: "16px", padding: "0px 3px" }}
        >
          {result && (
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                padding: "0px 3px",
                fontFamily: "Inter",
                fontWeight: "500",
                letterSpacing: "0%",
              }}
            >
              <div
                style={{
                  fontSize: isSmallScreen ? "20px" : "22px",
                  color: "#000000",
                }}
              >
                Shopping Lists
              </div>
              {/* {countLeftShoppingList > 0 && ( */}
              {false && (
                <Link
                  to={`${location.pathname}/shoppinglists`}
                  className="nav-link"
                  style={{
                    fontSize: isSmallScreen ? "12px" : "14px",
                    color: "#005FDA",
                  }}
                >
                  <u>View All {totalShoppingListCount} Shopping Lists</u>
                </Link>
              )}
            </div>
          )}
          {/* <div className="d-flex w-100 flex-wrap gap-2"> */}
          <div
            className="row mx-0"
            style={{ padding: isSmallScreen ? "0px 0px" : "10px 0px" }}
          >
            {allShoppingLists.length > 0 &&
              allShoppingLists.map((shoppingList, index) => (
                <>
                  <ShoppingList key={index} list={shoppingList} user={user} />
                </>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
